var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeaLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.8889C3 5.97969 7.02944 2 12 2C16.9706 2 21 5.97969 21 10.8889C21 16.2006 15.929 20.041 12.7799 21.6333C12.2877 21.8821 11.7123 21.8821 11.2201 21.6333C8.07101 20.041 3 16.2006 3 10.8889ZM13.9829 15.241C13.9763 14.9484 14.1452 14.6839 14.3949 14.5313C15.7182 13.7232 16.6015 12.2655 16.6015 10.6015C16.6015 8.06015 14.5413 6 12 6C9.45871 6 7.39856 8.06015 7.39856 10.6015C7.39856 12.2658 8.28214 13.7237 9.60579 14.5318C9.85611 14.6846 10.028 14.947 10.028 15.2403C10.028 15.6599 10.3681 16 10.7877 16H13.2408C13.6573 16 13.9923 15.6574 13.9829 15.241ZM9.9353 17.832C9.9353 18.2462 10.2711 18.582 10.6853 18.582H13.3147C13.7289 18.582 14.0647 18.2462 14.0647 17.832C14.0647 17.4178 13.7289 17.082 13.3147 17.082H10.6853C10.2711 17.082 9.9353 17.4178 9.9353 17.832Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaLocation);
export default __webpack_public_path__ + "static/media/idea-location.e7d714bad7864049d36532d83ae4acd0.svg";
export { ForwardRef as ReactComponent };